// Configuration for the development environment. Angular swaps this file in via the
// fileReplacements entry for each build configuration in angular.json.
import type { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
  '80002': {
    TRANSH_URL: "https://www.oklink.com/amoy/tx/",
    EXPLORER_URL: "https://www.oklink.com/amoy",
    FACTORY_ADDRESS: "0x12ba55372ec48125e35dE6b0a84866b681276Bf7",
    ACCESS_CONTROL_TOKEN: "0xDDE9256778596E949DEa33912c82312B1cd4066C",
    PROVIDER: "https://rpc-amoy.polygon.technology",
    PROVIDERS: ["https://rpc-amoy.polygon.technology", "https://polygon-amoy-bor-rpc.publicnode.com", "https://polygon-amoy.drpc.org"],
    CHAIN_NETWORK: "0x13882",
    CHAINID: 80002,
    CURRENCY_NAME: "MATIC",
    CURRENCY_SYMBOL: "MATIC",
    CHAIN_NAME: "Polygon Test Network",
    FILE_PATH: "",
    BORROW_LEND_CONTRACT: "0x27cB8E823B7e357B62DE0B4985dbf3261fAbEd51",
    EXCHANGE_CONTRACT: "0xE986659879107F408325120D0a154910545079C2",
    LAZYMINT_CONTRACT: "0x692D575C4F4753ec9aB7858E27a28092944F2cb0",
    ERC721_CONTRACT: "0x18c9a0EFF3C0394440De38acB1C63ABf6ad5B542",
    PLATFORM_FEE: "0x577b282078912c354b3f4b503c97Bf2770eCe2cC",
    ONBOARD_CONTRACT: "0xB11Bd85FEd80F8e12cf7d71c54eB2a5469d92D9F"
  },
  production: false,
  BASE_URL: "https://chocolate-magnificent-blackbird-410.mypinata.cloud/ipfs/",
  API_BASE_URL: "https://devapi.realworld.fi/api/v1",
  API_BASE_URL_V2: "https://devapi.realworld.fi/api/v2",
  API_BASE_URL_V3: "https://devapi.realworld.fi/api/v3",
  SUPPORTED_CHAINS: ["80002"],
  CHAIN_ID: "0x13882",
  WEB_SITE_URL: "https://devapp.realworld.fi",
  WALLET_CONNECT_PROJECT_ID: "b6c201630414d0fd586cfc6add82cde7",
  MARKETPLACE_URL: "https://devmarket.realworld.fi/",
  AUTO_LOGOUT_DURATION: 21600,
  AUTO_LOGOUT_TIMEOUT: 30,
  // Frontend error alerts to the ops Telegram channel, delivered through the backend relay
  // (no bot token or chat id in this file — they stay server-side).
  ENABLE_TELEGRAM_ERROR_ALERTS: true,
  TELEGRAM_TRACK_TOAST_ERRORS: true
} as AppEnvironment;
